/* eslint-disable import/no-extraneous-dependencies */
import React from 'react'
import styled from 'styled-components'
import { Accordion, AccordionItem } from '@szhsin/react-accordion'
import ParseContent from 'components/shared/ParseContent'
import Title from 'components/elements/Title'

const StyledAccordion = styled(Accordion)`
  display: flex;
  flex-direction: column;
  gap: 15px;

  & .szh-accordion__item {
    background-color: ${({ theme }) => theme.color.light};
    border-radius: 25px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
    overflow: hidden;
  }

  & .szh-accordion__item-btn {
    width: 100%;
    border: 0;
    background: transparent;
    text-align: left;
    padding: 24px 28px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 22px;
    line-height: 26px;
    font-family: ${({ theme }) => theme.font.family.secondary};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.color.dark};
  }

  & .szh-accordion__item-btn::after {
    content: '+';
    font-size: 28px;
    line-height: 1;
    color: ${({ theme }) => theme.color.primary};
    margin-left: 20px;
  }

  & .szh-accordion__item--expanded .szh-accordion__item-btn::after {
    content: '−';
  }

  & .szh-accordion__item-panel {
    padding: 0 28px 24px;
    color: ${({ theme }) => theme.color.grey};
  }

  @media (max-width: 991px) {
    gap: 12px;

    & .szh-accordion__item-btn {
      padding: 18px 20px;
      font-size: 18px;
      line-height: 22px;
    }

    & .szh-accordion__item-panel {
      padding: 0 20px 18px;
    }
  }
`

interface FAQProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Components
}

function FAQ({ fields }: FAQProps) {
  const { faq, title } = fields

  if (!faq) {
    return null
  }

  return (
    <section className="py-lg-5 py-3">
      <div className="container py-2">
        <div className="row">
          <div className="col-lg-10">
            {title && (
              <div className="mb-4">
                <Title small>{title}</Title>
              </div>
            )}
            <StyledAccordion transition transitionTimeout={200}>
              {faq.map((item: any) => (
                <AccordionItem key={item.question} header={item.question}>
                  <ParseContent content={item?.answer} />
                </AccordionItem>
              ))}
            </StyledAccordion>
          </div>
          <div className="col-lg-2" />
        </div>
      </div>
    </section>
  )
}

export default FAQ
